import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=1d20567a&scoped=true&"
import script from "./IconButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=1d20567a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d20567a",
  null
  
)

export default component.exports